export default "__VITE_ASSET__DwbS7Jdz__"